import axiosClient from './axiosClient';

export const emitTrackingEvent = (event) => {
	return axiosClient.post(`/tracking-event`, event)
}

export const emitUnsecureTrackingEvent = (event) => {
	return axiosClient.post(`/tracking-event/unsecure`, event)
}
